/**
 * Custom HTTP headers exchanged between the CK Go2 clients and the API.
 *
 * These live in one shared place on purpose. A custom request header has THREE call sites that
 * must agree: the client that sends it, the API handler that reads it, and the API's CORS
 * `allowHeaders` list that must permit it through the browser preflight. When those drift, the
 * browser silently blocks the request before it leaves the page and the failure surfaces as a
 * misleading "Cannot connect to server. Check your internet connection." on save — never a 4xx
 * you can debug. Importing the name from here keeps all three sites on a single source of truth.
 */

/**
 * Optimistic-concurrency header (Block 6.1). On an edit-save the admin echoes the `updatedAt` it
 * loaded; the API rejects a stale last-write-wins overwrite with a 409. Sent by the admin
 * (`useEditPage`), read by the API (`createCrudRouter`), and — critically — MUST be present in
 * the API CORS `allowHeaders` (`lib/corsConfig`) or the write preflight fails.
 */
export const OPTIMISTIC_LOCK_HEADER = "X-Base-Version";
